import type React from "react";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import type { Therapist } from "api/models/Therapist";
import { useAnalytics } from "utils/hooks/useAnalytics";
import { getBestLng } from "utils/locale";
import { userIsPartner } from "utils/profile/profileHelper";

import { ProfileContext } from "./ProfileContext";

const useProfileContextProvider = () => {
  const [profile, setProfile] = useState<Therapist | undefined>();
  const { i18n } = useTranslation();
  const isPartner = userIsPartner(profile);

  useEffect(() => {
    if (profile?.locale) {
      i18n.changeLanguage(getBestLng(profile.locale));
    }
  }, [i18n, profile]);

  useAnalytics(profile?.id, isPartner);

  const value = {
    profile,
    setProfile,
  };

  return value;
};

interface ProfileContextProviderProps {
  children: React.ReactNode;
}

export const ProfileContextProvider: React.FC<ProfileContextProviderProps> = ({ children }) => {
  const value = useProfileContextProvider();
  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
};

export type ProfileContextValue = ReturnType<typeof useProfileContextProvider>;
